import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.Toolbar.PayWithAmax.SchedulePaymentPopup', {
    title: 'Schedule payment',
    selectPaymentDate: 'Select payment date',
    create: 'Create',
});
